import { retentionViews } from '../../constants/retention';

const executeInitialState = {
  result: null,
  query: null,
  executeTime: 0,
  executing: false,
  executeId: '',
  options: {
    view: retentionViews.TABLE,
    views: Object.values(retentionViews),
    trendLine: false,
    averageLine: false,
    medianLine: false,
    adaptive: false,
    isExpand: false,
  },
};

const execute = (state = executeInitialState, action) => {
  switch (action.type) {
    case 'EXECUTE_RETENTION_QUERY_SUCCESS':
      return {
        ...state,
        result: action.result,
        query: action.query,
        executeTime: new Date().valueOf(),
        executing: false,
        executeId: '',
      };

    case 'EXECUTE_RETENTION_QUERY_FAILURE':
      return {
        ...state,
        executing: false,
        executeId: '',
      };

    case 'EXECUTE_RETENTION_QUERY':
      return {
        ...state,
        executing: true,
      };

    case 'SET_RETENTION_EXECUTE_ID':
      return {
        ...state,
        executeId: action.executeId,
      };

    case 'CHANGE_RETENTION_VIEW':
      return {
        ...state,
        options: {
          ...state.options,
          view: action.view,
        },
      };

    case 'TOGGLE_RETENTION_TREND_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          trendLine: !state.options.trendLine,
        },
      };

    case 'TOGGLE_RETENTION_AVERAGE_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          averageLine: !state.options.averageLine,
        },
      };

    case 'TOGGLE_RETENTION_MEDIAN_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          medianLine: !state.options.medianLine,
        },
      };

    case 'TOGGLE_RETENTION_ADAPTIVE':
      return {
        ...state,
        options: {
          ...state.options,
          adaptive: !state.options.adaptive,
        },
      };

    default:
      return state;
  }
};

export default execute;

export const getResult = (state) => state.result;

export const getQuery = (state) => state.query;

export const getOptions = (state) => state.options;

export const getExecuteTime = (state) => state.executeTime;

export const isExecuting = (state) => state.executing;

export const getExecuteId = (state) => state.executeId;
